import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Outlet } from 'react-router-dom';
import { Wordmark } from '@volvo-cars/react-icons';
import ICPMessage from '../../components/atoms/ICPMessage';
import { getContextValue } from '../../utils/globalContext';
import styles from './styles.module.css';
import { useTranslate } from '../../i18n';

const widePages = ['scopes.approval', 'error'];

const Layout = ({
  isReady = false,
  direction = 'ltr',
  colorMode = 'light',
  hasCookiesEnabled = true,
}) => {
  const cluster = getContextValue('REACT_APP_CLUSTER');
  const isChina = cluster.includes('cn');
  const pageId = getContextValue('pageId');
  const { translate } = useTranslate();

  // scopes approval page contains a lot of text, therefore we need to make the layout wider
  const isWide = widePages.includes(pageId) || !hasCookiesEnabled;

  return (
    <div
      className={classNames(
        'relative',
        'flex-col',
        'justify-between',
        'min-h-full',
        colorMode === 'dark' ? 'bg-secondary' : 'bg-primary',
      )}
      dir={direction}
      data-color-mode={colorMode}
    >
      <div className="min-h-full flex-col flex-grow">
        <header className="flex-row items-center h-64 bg-secondary px-16 md:px-24 py-16 md:py-24">
          <Wordmark alt="Volvo logo" />
        </header>
        {isReady && (
          <main className={classNames(styles.content, isWide && styles.wide)}>
            {hasCookiesEnabled && <Outlet />}
            {!hasCookiesEnabled && (
              <div>
                <h1 className="heading-3 mb-32">
                  {translate('disabled_cookies_title')}
                </h1>
                <p className="text-secondary font-16">
                  {translate('disabled_cookies_info')}
                </p>
              </div>
            )}
          </main>
        )}
      </div>
      {isChina && <ICPMessage />}
    </div>
  );
};

Layout.propTypes = {
  isReady: PropTypes.bool.isRequired,
  direction: PropTypes.string.isRequired,
  colorMode: PropTypes.string,
  hasCookiesEnabled: PropTypes.bool,
};

export default Layout;
